import {
    Widget,
    addResponseMessage,
    setQuickButtons,
    deleteMessages,
    addUserMessage
} from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import {
    useEffect,
    useState,
    useImperativeHandle,
    forwardRef
} from 'react';
import useOnceCall from './useOneCall';

const ChatWidget = forwardRef((props, ref) => {
    const [chatWindowOpen, setChatWindowOpen] = useState(true);
    const [messageQueue, setMessageQueue] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useOnceCall(() => {
        setMessageQueue(queue => [...queue, "Merhaba! Size nasıl yardımcı olabilirim?"]);
        setQuickButtons(props.quickButtons);
    }, []);

    useEffect(() => {
        if (messageQueue.length > 0) {
            const msg = messageQueue[0];
            addResponseMessage(msg);
            setMessageQueue(queue => queue.slice(1));
        }
    }, [messageQueue]);

    useImperativeHandle(ref, () => ({
        addAIResponse: (msg) => {
            if (isLoading) {
                deleteMessages(1);
                setIsLoading(false);
            }

            setTimeout(() => {
                setMessageQueue(queue => [...queue, msg]);

                setQuickButtons(props.quickButtons);
            }, 100);
        },
        addUserMsg: (msg) => {
            addUserMessage(msg);
        }
    }));

    const handleToggle = () => {
        setChatWindowOpen(prev => !prev);
    };

    const handleQuickButtonClicked = (value) => {
        if (isLoading) return;

        addUserMessage(value);

        setIsLoading(true);
        addResponseMessage("Analiz ediliyor...");
        setQuickButtons([]);
        props.handleNewUserMessage(value);
    };

    const handleNewUserMessage = (message) => {
        if (isLoading) return;

        addUserMessage(message);

        setIsLoading(true);
        addResponseMessage("Analiz ediliyor...");
        setQuickButtons([]);
        props.handleNewUserMessage(message);
    };

    return (
        <Widget
            handleNewUserMessage={handleNewUserMessage}
            handleQuickButtonClicked={handleQuickButtonClicked}
            title="Levelup CRM AI"
            subtitle=""
            showCloseButton={true}
            fullScreenMode={false}
            handleToggle={handleToggle}
            emojis={false}
            senderPlaceHolder="Mesajınızı yazın..."
            showTimeStamp={false}
            launcherOpenImg={`${process.env.PUBLIC_URL}/assets/images/icons/chat-icon.png`}
            profileAvatar={`${process.env.PUBLIC_URL}/assets/images/icons/ai-icon.png`}
            disableInput={isLoading}
        />
    );
});

export default ChatWidget;
